import { useMemo } from 'react';
import { Row, Col } from 'antd';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFArrowLeft from '@/components/UI/svg/Icons/EFArrowLeft';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/collection/');

type IContext = {
    name: string;
    desc: string;
    imgSrc: string;
    imgHoverSrc: string;
    detLink: string;
    type: 'large' | 'middle' | 'small';
};
export interface ISolutionsMainProp {
    headerData: IContext[];
    contextList: IContext[];
}

const SolarGenSingleItem = ({ itemData, index }: any) => {
    const { Link, useLang } = useGlobal();
    const { t } = useLang('shared');
    const moreText = t('support.site_support_learn_more');

    return (
        <div className="single-item">
            {index === 0 ? <h1 className="title">{itemData.name}</h1> : <p className="title">{itemData.name}</p>}
            <p className="subtitle">{itemData.desc}</p>
            <div className="learn-more">
                {itemData.detLink && (
                    <Link href={itemData.detLink} className="learnMore">
                        <span className="moreText">{moreText}</span>
                        <span className="svg-wrapper">
                            <EFArrowLeft />
                        </span>
                    </Link>
                )}
                {itemData?.comLink && (
                    <Link href={itemData.comLink} className="learnMore comMore">
                        <span className="moreText">{itemData?.comText}</span>
                        <span className="svg-wrapper">
                            <EFArrowLeft />
                        </span>
                    </Link>
                )}
            </div>
            <div className="img-wrapper">
                <EFPic name={itemData.imgSrc} className="fullImgs" noUseSrcset={true} alt={itemData.name} aria-label={itemData.name} />
            </div>
        </div>
    );
};

const SolutionsMain = ({ headerData, contextList }: ISolutionsMainProp) => {
    const { Link, isMobile, useLang } = useGlobal();
    const { t } = useLang('shared');
    const moreText = t('support.site_support_learn_more');

    const mobileHtml = useMemo(() => {
        const arr = headerData?.filter((item: any) => item.type === 'large');
        contextList.map((item) => arr.push(item));
        return arr.map((item: any, indx: number) => {
            return (
                <div key={indx} className={`product-wrapper${item.type === 'large' ? ' first-item' : ''}`}>
                    <SolarGenSingleItem itemData={item} index={indx} />
                </div>
            );
        });
    }, [contextList, headerData]);

    const pcHtml = useMemo(() => {
        return (
            <>
                {headerData
                    ?.filter((item: any) => item.type === 'large')
                    ?.map((headerItem: any, k: number) => (
                        <div className="solutions_banner" key={k}>
                            <div className="banner_text">
                                <h1 className="title">{headerItem.name}</h1>
                                <p className="subtitle">{headerItem.desc}</p>
                                <div className="learn-more">
                                    <Link href={headerItem.detLink} className="learnMore">
                                        <span className="moreText">{moreText}</span>
                                        <span className="svg-wrapper">
                                            <EFArrowLeft />
                                        </span>
                                    </Link>
                                    {headerItem?.comLink && (
                                        <Link href={headerItem.comLink} className="learnMore comMore">
                                            <span className="moreText">{headerItem?.comText}</span>
                                            <span className="svg-wrapper">
                                                <EFArrowLeft />
                                            </span>
                                        </Link>
                                    )}
                                </div>
                            </div>
                            <div className="imgbox">
                                <EFPic name={headerItem.imgSrc} className="fullImgs" noUseSrcset={true} alt={headerItem.name} aria-label={headerItem.name} />
                            </div>
                        </div>
                    ))}
                <div className="solutions_content">
                    <Row gutter={[20, 20]} justify="space-between" align="top">
                        {contextList.map((item, index) => {
                            return (
                                <Col span={item.type === 'small' ? 12 : 24} key={index}>
                                    <div className={`context_item ${item.type}`}>
                                        <div>
                                            <h6 className="title">{item.name}</h6>
                                            {item.desc ? <p className="subtitle">{item.desc}</p> : ''}
                                            <div className="learn-more">
                                                {item.detLink && (
                                                    <Link href={item.detLink} className="learnMore">
                                                        <span className="moreText">{moreText}</span>
                                                        <span className="svg-wrapper">
                                                            <EFArrowLeft />
                                                        </span>
                                                    </Link>
                                                )}
                                            </div>
                                        </div>
                                        <div className="imgbox">
                                            <div className="befor">
                                                <EFPic name={item.imgSrc} className="fullImgs" noUseSrcset={true} alt={item.name} aria-label={item.name} />
                                            </div>
                                            <div className="after">
                                                <EFPic name={item.imgHoverSrc} className="fullImgs" noUseSrcset={true} alt={item.name} aria-label={item.name} />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            );
                        })}
                    </Row>
                </div>
            </>
        );
    }, [contextList, headerData]);

    return <div className={`${isMobile ? styled.solutions_mobile : styled.solutions_main}`}>{isMobile ? mobileHtml : pcHtml}</div>;
};

export default SolutionsMain;
